import { render, staticRenderFns } from "./registro_edicion_memorando.vue?vue&type=template&id=4cbf1e7e&scoped=true"
import script from "./registro_edicion_memorando.vue?vue&type=script&lang=js"
export * from "./registro_edicion_memorando.vue?vue&type=script&lang=js"
import style0 from "./registro_edicion_memorando.vue?vue&type=style&index=0&id=4cbf1e7e&prod&scoped=true&lang=css"
import style1 from "./registro_edicion_memorando.vue?vue&type=style&index=1&id=4cbf1e7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbf1e7e",
  null
  
)

export default component.exports